var app;

app = angular.module('app', ['ionic', 'ionic-material']);

app.config(function($stateProvider, $urlRouterProvider) {
  $stateProvider.state('app', {
    url: '',
    abstract: true,
    templateUrl: 'apps/templates/menu',
    controller: 'AppController',
    resolve: {
      activeProject: function($http, $location, $ionicPopup, $state, activeUser, config) {
        var getParameterByName, group_id, openid, wechat_id;
        getParameterByName = function(name) {
          var regex, regexS, results;
          name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
          regexS = "[\\?&]" + name + "=([^&#]*)";
          regex = new RegExp(regexS);
          results = regex.exec(window.location.search);
          if (results == null) {
            return "";
          } else {
            return decodeURIComponent(results[1].replace(/\+/g, " "));
          }
        };
        group_id = getParameterByName('group_id');
        activeUser.group_id = group_id;
        activeUser.user = {
          headimgurl: ''
        };
        openid = getParameterByName('openid');
        wechat_id = getParameterByName('wechat_id');
        activeUser.wechat_id = wechat_id;
        if (group_id && openid) {
          return $http.get(config.api.baseUrl + "/fans-get/" + openid, {}).then(function(res) {
            var userInfo;
            userInfo = res.data;
            userInfo.headimgurl = "http://microdata2-api.ersinfotech.com/imgserve?_url=" + userInfo.headimgurl;
            return activeUser.user = userInfo;
          }).then(function() {
            return $http.get(config.api.baseUrl + "/cumpus/homepage", {
              params: {
                group_id: group_id
              }
            }).then(function(res) {
              if (res.data.data.length > 0) {
                return activeUser.homepage = res.data.data[0];
              }
            })["catch"](function(error) {});
          })["catch"](function(error) {
            return $ionicPopup.alert({
              title: "错误",
              template: "获取用户信息失败",
              buttons: [
                {
                  text: '<b>关闭</b>',
                  type: 'button-positive'
                }
              ]
            });
          });
        } else {
          return $http.get(config.api.baseUrl + "/cumpus/homepage", {
            params: {
              group_id: group_id
            }
          }).then(function(res) {
            if (res.data.data.length > 0) {
              return activeUser.homepage = res.data.data[0];
            }
          })["catch"](function(error) {});
        }
      }
    }
  }).state('app.home', {
    cache: true,
    url: '/home',
    views: {
      'menuContent': {
        templateUrl: 'apps/templates/home',
        controller: 'HomeController'
      }
    }
  }).state('app.article_list', {
    cache: true,
    url: '/article_list/:column_id',
    views: {
      'menuContent': {
        templateUrl: 'apps/templates/article_list',
        controller: 'ArticleListController'
      }
    }
  }).state('app.single_article', {
    cache: true,
    url: '/single_article/:column_id',
    views: {
      'menuContent': {
        templateUrl: 'apps/templates/single_article',
        controller: 'SingleArticleController'
      }
    }
  }).state('app.top_new', {
    cache: true,
    url: '/top_new/:new_id',
    views: {
      'menuContent': {
        templateUrl: 'apps/templates/top_new',
        controller: 'TopNewController'
      }
    }
  }).state('app.article', {
    cache: true,
    url: '/article/:column_id/:article_id',
    views: {
      'menuContent': {
        templateUrl: 'apps/templates/article',
        controller: 'ArticleController'
      }
    }
  }).state('app.images', {
    cache: true,
    url: '/images/:column_id',
    views: {
      'menuContent': {
        templateUrl: 'apps/templates/images',
        controller: 'ImagesController'
      }
    }
  }).state('app.external_link', {
    cache: true,
    url: '/external_link/:column_id',
    views: {
      'menuContent': {
        templateUrl: 'apps/templates/external_link',
        controller: 'ExternalLinkController'
      }
    }
  }).state('app.authentication_info', {
    cache: false,
    url: '/authentication_info/:status',
    views: {
      'menuContent': {
        templateUrl: 'apps/templates/authentication_info',
        controller: 'AuthenticationInfoController'
      }
    }
  }).state('app.verify_success', {
    cache: false,
    url: '/verify_success/:user_id/:status',
    views: {
      'menuContent': {
        templateUrl: 'apps/templates/verify_success',
        controller: 'VerifySuccessController'
      }
    }
  }).state('focus_on', {
    cache: false,
    url: '/focus_on/:wechat_id',
    templateUrl: 'apps/templates/focus_on',
    controller: 'FocusOnController'
  });
  return $urlRouterProvider.otherwise('/home');
});

angular.module('app').controller('AppController', function($timeout, $rootScope, $scope, $http, $state, $ionicPopup, $ionicLoading, config, activeUser, ionicMaterialInk) {
  $rootScope.$on('$routeChangeStart', function() {
    return $ionicLoading.show();
  });
  $rootScope.$on('$routeChangeSuccess', function() {
    return $ionicLoading.hide();
  });
  $scope.appConfig = {
    baseUrl: config.api.baseUrl,
    userInfo: activeUser.user,
    homepage: activeUser.homepage
  };
  $scope.toHome = function() {
    return $state.go("app.home", {});
  };
  $scope.toAuthenticationInfo = function() {
    return $state.go("app.authentication_info", {
      status: '0'
    });
  };
  return $timeout((function() {
    return ionicMaterialInk.displayEffect();
  }), 1000);
});

angular.module('app').controller('ArticleController', function($scope, $http, $state, $stateParams, $sce, $ionicPopup, config, activeUser) {
  var findArticle, findColumn;
  $scope.ui = {
    title: '',
    baseUrl: config.api.baseUrl,
    homepage: activeUser.homepage,
    userInfo: activeUser.user,
    column: {},
    article: {},
    content_html: null
  };
  (findColumn = function() {
    return $http.get(config.api.baseUrl + "/cumpus/programa/" + $stateParams.column_id, {}).then(function(res) {
      $scope.ui.column = res.data;
      return $scope.ui.title = $scope.ui.column.programa_name;
    })["catch"](function(error) {
      return $ionicPopup.alert({
        title: "錯誤",
        template: "系統出錯！",
        buttons: [
          {
            text: '<b>關閉</b>',
            type: 'button-positive'
          }
        ]
      });
    });
  })();
  return (findArticle = function() {
    return $http.get(config.api.baseUrl + "/cumpus/programa/list/" + $stateParams.article_id, {
      params: {
        is_content: true,
        programa_id: $stateParams.column_id,
        group_id: activeUser.group_id
      }
    }).then(function(res) {
      $scope.ui.article = res.data;
      $scope.ui.article.release_time = moment($scope.ui.article.release_time).format('YYYY-MM-DD');
      $scope.ui.article.data.content = $scope.ui.article.data.content.replace(/\"http\:\/\/mmbiz.qpic.cn/g, '"' + config.api.baseUrl + '/imgserve?_url=http://mmbiz.qpic.cn').replace(/\(http\:\/\/mmbiz.qpic.cn/g, '(' + config.api.baseUrl + '/imgserve?_url=http://mmbiz.qpic.cn').replace(/\&quot;http\:\/\/mmbiz.qpic.cn/g, '&quot;' + config.api.baseUrl + '/imgserve?_url=http://mmbiz.qpic.cn').replace(/\"https\:\/\/mmbiz.qpic.cn/g, '"' + config.api.baseUrl + '/imgserve?_url=https://mmbiz.qpic.cn').replace(/\(https\:\/\/mmbiz.qpic.cn/g, '(' + config.api.baseUrl + '/imgserve?_url=https://mmbiz.qpic.cn').replace(/\&quot;https\:\/\/mmbiz.qpic.cn/g, '&quot;' + config.api.baseUrl + '/imgserve?_url=https://mmbiz.qpic.cn');
      return $scope.ui.content_html = $sce.trustAsHtml($scope.ui.article.data.content);
    })["catch"](function(error) {
      return $ionicPopup.alert({
        title: "錯誤",
        template: "系統錯誤！",
        buttons: [
          {
            text: '<b>關閉</b>',
            type: 'button-positive'
          }
        ]
      });
    });
  })();
});

angular.module('app').controller('ArticleListController', function($window, $timeout, $scope, $http, $state, $stateParams, $ionicPopup, config, activeUser, ionicMaterialInk) {
  var findArticles, findColumn;
  $scope.ui = {
    load_show: false,
    baseUrl: config.api.baseUrl,
    homepage: activeUser.homepage,
    title: '',
    userInfo: activeUser.user,
    column: {},
    count: 0,
    articles: []
  };
  (findColumn = function() {
    return $http.get(config.api.baseUrl + "/cumpus/programa/" + $stateParams.column_id, {}).then(function(res) {
      $scope.ui.column = res.data;
      return $scope.ui.title = $scope.ui.column.programa_name;
    })["catch"](function(error) {
      return $ionicPopup.alert({
        title: "錯誤",
        template: "系統錯誤！",
        buttons: [
          {
            text: '<b>關閉</b>',
            type: 'button-positive'
          }
        ]
      });
    });
  })();
  findArticles = function() {
    return $http.get(config.api.baseUrl + "/cumpus/programa/list", {
      params: {
        is_show: true,
        programa_id: $stateParams.column_id,
        group_id: activeUser.group_id,
        sort: '-release_time',
        end_release_time: String(moment().add('d', 1)),
        offset: $scope.ui.articles.length,
        limit: 8
      }
    }).then(function(res) {
      var articles;
      articles = res.data.data;
      _.each(articles, function(val) {
        return val.release_time = moment(val.release_time).format('YYYY-MM-DD');
      });
      $scope.ui.articles = $scope.ui.articles.concat(articles);
      $scope.ui.count = res.data.count;
      if ($scope.ui.articles.length === $scope.ui.count) {
        $scope.ui.load_show = true;
      }
      $scope.$broadcast('scroll.infiniteScrollComplete');
      return $timeout((function() {
        return ionicMaterialInk.displayEffect();
      }), 1000);
    })["catch"](function(error) {
      return $ionicPopup.alert({
        title: "錯誤",
        template: "系統錯誤！",
        buttons: [
          {
            text: '<b>關閉</b>',
            type: 'button-positive'
          }
        ]
      });
    });
  };
  $scope.findArticles = findArticles;
  return $scope.toOpen = function(link) {
    return $window.open(link);
  };
});

angular.module('app').controller('AuthenticationInfoController', function($timeout, $stateParams, $scope, $http, $state, $ionicPopup, config, activeUser, ionicMaterialInk) {
  var findClass, findParent, findStudent;
  if (_.isUndefined(activeUser.user.openid)) {
    $state.go('focus_on', {
      wechat_id: activeUser.wechat_id
    });
  }
  $scope.ui = {
    baseUrl: config.api.baseUrl,
    status: $stateParams.status ? $stateParams.status : '0',
    types: 'parent',
    homepage: activeUser.homepage,
    userInfo: activeUser.user,
    classData: {},
    student_id: '',
    pstudent_id: '',
    student_class: '',
    student_grade: '',
    student_num: '',
    identity: 'mother',
    school_num: '019',
    verification_code: '',
    parent_code: ''
  };
  (findParent = function() {
    return $http.get(config.api.baseUrl + "/cumpus/student", {
      params: {
        parent_openid: activeUser.user.openid,
        group_id: activeUser.group_id
      }
    }).then(function(res) {
      if (res.data.count > 0 && $stateParams.status === '0') {
        $state.go("app.verify_success", {
          user_id: res.data.data[0]._id,
          status: 'parent'
        });
      } else {
        findStudent();
      }
      return $timeout((function() {
        return ionicMaterialInk.displayEffect();
      }), 1000);
    })["catch"](function(error) {});
  })();
  findStudent = function() {
    return $http.get(config.api.baseUrl + "/cumpus/student", {
      params: {
        openid: activeUser.user.openid,
        group_id: activeUser.group_id
      }
    }).then(function(res) {
      if (res.data.count > 0 && $stateParams.status === '0') {
        $state.go("app.verify_success", {
          user_id: res.data.data[0]._id,
          status: 'student'
        });
      }
      return $timeout((function() {
        return ionicMaterialInk.displayEffect();
      }), 1000);
    })["catch"](function(error) {});
  };
  (findClass = function() {
    return $http.get(config.api.baseUrl + "/cumpus/class", {
      params: {
        group_id: activeUser.group_id
      }
    }).then(function(res) {
      var res_class, res_grade;
      res.data.student_grade = res.data.student_grade.sort();
      res_class = [];
      res_grade = [];
      _.each(res.data.student_class, function(val) {
        var obj;
        obj = {};
        obj.name = val;
        obj.key = (function() {
          switch (val) {
            case "甲":
              return 1;
            case "乙":
              return 2;
            case "丙":
              return 3;
            case "丁":
              return 4;
            case "戊":
              return 5;
            case "己":
              return 6;
            case "庚":
              return 7;
            case "辛":
              return 8;
            case "壬":
              return 9;
            case "癸":
              return 10;
          }
        })();
        return res_class.push(obj);
      });
      res.data.student_class = _.sortBy(res_class, "key");
      _.each(res.data.student_grade, function(val) {
        var obj;
        obj = {};
        obj.name = val;
        obj.key = (function() {
          switch (val) {
            case "幼兒":
              return 1;
            case "幼初":
              return 2;
            case "幼高":
              return 3;
            case "小一":
              return 4;
            case "小二":
              return 5;
            case "小三":
              return 6;
            case "小四":
              return 7;
            case "小五":
              return 8;
            case "小六":
              return 9;
            case "初一":
              return 10;
            case "初二":
              return 11;
            case "初三":
              return 12;
            case "高一":
              return 13;
            case "高二":
              return 14;
            case "高三":
              return 15;
          }
        })();
        return res_grade.push(obj);
      });
      res.data.student_grade = _.sortBy(res_grade, "key");
      return $scope.ui.classData = res.data;
    })["catch"](function(error) {});
  })();
  return $scope.toCheck = function() {
    var params;
    params = {
      openid: activeUser.user.openid,
      original_id: activeUser.user.original_id,
      group_id: activeUser.group_id,
      student_id: $scope.ui.pstudent_id,
      school_num: $scope.ui.school_num,
      student_grade: $scope.ui.student_grade,
      student_class: $scope.ui.student_class,
      student_num: $scope.ui.student_num,
      identity: $scope.ui.identity,
      is_show: true
    };
    if ($scope.ui.types === 'parent') {
      if ($scope.ui.parent_code.length > 0) {
        params.parent_code = $scope.ui.parent_code;
      }
      if ($scope.ui.pstudent_id === "") {
        $ionicPopup.alert({
          title: "錯誤",
          template: "請輸入學生帳號",
          buttons: [
            {
              text: '<b>關閉</b>',
              type: 'button-positive'
            }
          ]
        });
        return;
      }
      if ($scope.ui.student_grade === "" || $scope.ui.student_grade === null) {
        $ionicPopup.alert({
          title: "錯誤",
          template: "請選擇學生年級",
          buttons: [
            {
              text: '<b>關閉</b>',
              type: 'button-positive'
            }
          ]
        });
        return;
      }
      if ($scope.ui.student_class === "" || $scope.ui.student_class === null) {
        $ionicPopup.alert({
          title: "錯誤",
          template: "請選擇學生班級",
          buttons: [
            {
              text: '<b>關閉</b>',
              type: 'button-positive'
            }
          ]
        });
        return;
      }
      if ($scope.ui.student_num === "") {
        $ionicPopup.alert({
          title: "錯誤",
          template: "請輸入學生學號",
          buttons: [
            {
              text: '<b>關閉</b>',
              type: 'button-positive'
            }
          ]
        });
        return;
      }
      if ($scope.ui.identity === "") {
        $ionicPopup.alert({
          title: "錯誤",
          template: "請輸入家長身份",
          buttons: [
            {
              text: '<b>關閉</b>',
              type: 'button-positive'
            }
          ]
        });
        return;
      }
      params.phone = $scope.ui.phone;
      params.student_num = $scope.ui.student_num;
      return $http.put(config.api.baseUrl + "/cumpus/certification/parents", params).then(function(res) {
        return $state.go("app.verify_success", {
          user_id: res.data,
          status: 'parent'
        });
      })["catch"](function(res) {
        var template;
        template = '驗證失敗！';
        if (res.data.error.indexOf('parent is verified') > -1) {
          template = '已被驗證！';
        }
        return $ionicPopup.alert({
          title: "錯誤",
          template: template,
          buttons: [
            {
              text: '<b>關閉</b>',
              type: 'button-positive'
            }
          ]
        });
      });
    } else {
      if ($scope.ui.student_id === "") {
        $ionicPopup.alert({
          title: "错误",
          template: "請輸入學生帳號",
          buttons: [
            {
              text: '<b>关闭</b>',
              type: 'button-positive'
            }
          ]
        });
        return;
      }
      if ($scope.ui.verification_code === "") {
        $ionicPopup.alert({
          title: "错误",
          template: "請輸入驗證編碼",
          buttons: [
            {
              text: '<b>关闭</b>',
              type: 'button-positive'
            }
          ]
        });
        return;
      }
      params.verification_code = $scope.ui.verification_code;
      params.student_id = $scope.ui.student_id;
      return $http.put(config.api.baseUrl + "/cumpus/certification/students", params).then(function(res) {
        return $state.go("app.verify_success", {
          user_id: res.data,
          status: 'student'
        });
      })["catch"](function(res) {
        var template;
        template = '驗證失敗！';
        if (res.data.error.indexOf('student is verified') > -1) {
          template = '已被驗證！';
        }
        return $ionicPopup.alert({
          title: "錯誤",
          template: template,
          buttons: [
            {
              text: '<b>關閉</b>',
              type: 'button-positive'
            }
          ]
        });
      });
    }
  };
});

angular.module('app').controller('ExternalLinkController', function($scope, $http, $state, $sce, $stateParams, $ionicPopup, config, activeUser) {
  var findColumn;
  $scope.ui = {
    baseUrl: config.api.baseUrl,
    homepage: activeUser.homepage,
    title: '',
    userInfo: activeUser.user,
    column: {}
  };
  (findColumn = function() {
    return $http.get(config.api.baseUrl + "/cumpus/programa/" + $stateParams.column_id, {}).then(function(res) {
      $scope.ui.column = res.data;
      return $scope.ui.title = $scope.ui.column.programa_name;
    })["catch"](function(error) {
      return $ionicPopup.alert({
        title: "錯誤",
        template: "系統出錯！",
        buttons: [
          {
            text: '<b>關閉</b>',
            type: 'button-positive'
          }
        ]
      });
    });
  })();
  return $scope.trustSrc = function(url) {
    return $sce.trustAsResourceUrl(url);
  };
});

angular.module('app').controller('FocusOnController', function($scope, $stateParams) {
  return $scope.ui = {
    wechat_id: $stateParams.wechat_id
  };
});

angular.module('app').controller('HomeController', function($window, $timeout, $scope, $http, $state, $ionicPopup, config, activeUser, ionicMaterialInk) {
  var findColumns, findSlides;
  $scope.ui = {
    userInfo: activeUser.user,
    baseUrl: config.api.baseUrl,
    activeIndex: 0,
    homepage: activeUser.homepage,
    slides: [],
    columns: [],
    topNew: []
  };
  $scope.pageClick = function(index) {
    return $scope.ui.activeIndex = index;
  };
  $scope.slideHasChanged = function($index) {};
  $scope.toArticle = function(article) {
    return $state.go("app.article", {
      column_id: article.programa_id,
      article_id: article._id
    });
  };
  $scope.toTopNew = function(topNew) {
    if (topNew.type === 'link') {
      return $window.open(topNew.link);
    } else {
      return $state.go("app.top_new", {
        new_id: topNew._id
      });
    }
  };
  $scope.goMenu = function(column) {
    if (column.type === '1' || column.type === '5' || column.type === '6') {
      return $state.go("app.article_list", {
        column_id: column._id
      });
    } else if (column.type === '2') {
      return $state.go("app.single_article", {
        column_id: column._id
      });
    } else if (column.type === '3') {
      return $state.go("app.images", {
        column_id: column._id
      });
    } else if (column.type === '4') {
      return $state.go("app.external_link", {
        column_id: column._id
      });
    }
  };
  (findSlides = function() {
    return $http.get(config.api.baseUrl + "/cumpus/headline", {
      params: {
        limit: 8,
        offset: 0,
        group_id: activeUser.group_id,
        sort: 'sort',
        is_show: true
      }
    }).then(function(res) {
      return $scope.ui.slides = res.data.data;
    })["catch"](function(error) {
      return $ionicPopup.alert({
        title: "錯誤",
        template: "系統出錯！",
        buttons: [
          {
            text: '<b>關閉</b>',
            type: 'button-positive'
          }
        ]
      });
    });
  })();
  return (findColumns = function() {
    var ref;
    if (((ref = $scope.ui.homepage.layouts) != null ? ref.length : void 0) > 0) {
      return _.each($scope.ui.homepage.layouts, function(layout) {
        if (layout.is_useing === true) {
          $scope.ui.columns = _.filter(layout.mobileMenusNew, function(data) {
            if (data._id !== void 0) {
              return data;
            }
          });
          return $timeout((function() {
            return ionicMaterialInk.displayEffect();
          }), 1000);
        }
      });
    }
  })();
});

angular.module('app').controller('ImagesController', function($timeout, $scope, $http, $state, $stateParams, $ionicPopup, config, activeUser, ionicMaterialInk) {
  var findColumn, findImages;
  $scope.ui = {
    load_show: false,
    title: '',
    baseUrl: config.api.baseUrl,
    homepage: activeUser.homepage,
    userInfo: activeUser.user,
    column: {},
    images: [],
    count: 0
  };
  (findColumn = function() {
    return $http.get(config.api.baseUrl + "/cumpus/programa/" + $stateParams.column_id, {}).then(function(res) {
      $scope.ui.column = res.data;
      return $scope.ui.title = $scope.ui.column.programa_name;
    })["catch"](function(error) {
      return $ionicPopup.alert({
        title: "錯誤",
        template: "系統出錯！",
        buttons: [
          {
            text: '<b>關閉</b>',
            type: 'button-positive'
          }
        ]
      });
    });
  })();
  findImages = function() {
    return $http.get(config.api.baseUrl + "/cumpus/programa/list", {
      params: {
        is_show: true,
        programa_id: $stateParams.column_id,
        group_id: activeUser.group_id,
        sort: '-created_at',
        offset: $scope.ui.images.length,
        limit: 8
      }
    }).then(function(res) {
      var images;
      images = res.data.data;
      _.each(images, function(val) {
        return val.created_at = moment(val.created_at).format('YYYY-MM-DD');
      });
      $scope.ui.images = $scope.ui.images.concat(images);
      $scope.ui.count = res.data.count;
      if ($scope.ui.images.length === $scope.ui.count) {
        $scope.ui.load_show = true;
      }
      $scope.$broadcast('scroll.infiniteScrollComplete');
      return $timeout((function() {
        return ionicMaterialInk.displayEffect();
      }), 1000);
    })["catch"](function(error) {
      return $ionicPopup.alert({
        title: "錯誤",
        template: "系統出錯！",
        buttons: [
          {
            text: '<b>關閉</b>',
            type: 'button-positive'
          }
        ]
      });
    });
  };
  $scope.findImages = findImages;
  return $scope.toArticle = function(article) {
    return $state.go("app.article", {
      column_id: $stateParams.column_id,
      article_id: article._id
    });
  };
});

angular.module('app').controller('SingleArticleController', function($scope, $http, $state, $sce, $stateParams, $ionicPopup, config, activeUser) {
  var findArticle, findColumn;
  $scope.ui = {
    baseUrl: config.api.baseUrl,
    homepage: activeUser.homepage,
    title: '',
    userInfo: activeUser.user,
    column: {},
    article: {},
    content_html: null
  };
  (findColumn = function() {
    return $http.get(config.api.baseUrl + "/cumpus/programa/" + $stateParams.column_id, {}).then(function(res) {
      $scope.ui.column = res.data;
      return $scope.ui.title = $scope.ui.column.programa_name;
    })["catch"](function(error) {
      return $ionicPopup.alert({
        title: "錯誤",
        template: "系統出錯！",
        buttons: [
          {
            text: '<b>關閉</b>',
            type: 'button-positive'
          }
        ]
      });
    });
  })();
  return (findArticle = function() {
    return $http.get(config.api.baseUrl + "/cumpus/programa/list", {
      params: {
        is_content: true,
        programa_id: $stateParams.column_id,
        group_id: activeUser.group_id
      }
    }).then(function(res) {
      if (res.data.data.length > 0) {
        $scope.ui.article = res.data.data[0];
        $scope.ui.article.created_at = moment($scope.ui.article.created_at).format('YYYY-MM-DD');
        return $scope.ui.content_html = $sce.trustAsHtml($scope.ui.article.data.content);
      }
    })["catch"](function(error) {
      return $ionicPopup.alert({
        title: "錯誤",
        template: "系統出錯！",
        buttons: [
          {
            text: '<b>關閉</b>',
            type: 'button-positive'
          }
        ]
      });
    });
  })();
});

angular.module('app').controller('TopNewController', function($scope, $http, $state, $stateParams, $sce, $ionicPopup, config, activeUser) {
  var findAd;
  $scope.ui = {
    baseUrl: config.api.baseUrl,
    homepage: activeUser.homepage,
    userInfo: activeUser.user,
    topNew: {},
    content_html: null
  };
  return (findAd = function() {
    return $http.get(config.api.baseUrl + "/cumpus/headline/" + $stateParams.new_id, {
      params: {
        group_id: activeUser.group_id
      }
    }).then(function(res) {
      $scope.ui.topNew = res.data;
      $scope.ui.topNew.content = $scope.ui.topNew.content.replace(/\"http\:\/\/mmbiz.qpic.cn/g, '"' + config.api.baseUrl + '/imgserve?_url=http://mmbiz.qpic.cn').replace(/\(http\:\/\/mmbiz.qpic.cn/g, '(' + config.api.baseUrl + '/imgserve?_url=http://mmbiz.qpic.cn').replace(/\&quot;http\:\/\/mmbiz.qpic.cn/g, '&quot;' + config.api.baseUrl + '/imgserve?_url=http://mmbiz.qpic.cn').replace(/\"https\:\/\/mmbiz.qpic.cn/g, '"' + config.api.baseUrl + '/imgserve?_url=https://mmbiz.qpic.cn').replace(/\(https\:\/\/mmbiz.qpic.cn/g, '(' + config.api.baseUrl + '/imgserve?_url=https://mmbiz.qpic.cn').replace(/\&quot;https\:\/\/mmbiz.qpic.cn/g, '&quot;' + config.api.baseUrl + '/imgserve?_url=https://mmbiz.qpic.cn');
      return $scope.ui.content_html = $sce.trustAsHtml($scope.ui.topNew.content);
    })["catch"](function(error) {
      return $ionicPopup.alert({
        title: "錯誤",
        template: "系統出錯！",
        buttons: [
          {
            text: '<b>關閉</b>',
            type: 'button-positive'
          }
        ]
      });
    });
  })();
});

angular.module('app').controller('VerifySuccessController', function($timeout, $stateParams, $scope, $http, $state, $ionicPopup, config, activeUser, ionicMaterialInk) {
  var doRemoveParent, doRemoveParents, doRemoveStudent, findParent, findStudent;
  if (_.isUndefined(activeUser.user.openid)) {
    $state.go('focus_on', {
      wechat_id: activeUser.wechat_id
    });
  }
  $scope.ui = {
    baseUrl: config.api.baseUrl,
    status: $stateParams.status,
    homepage: activeUser.homepage,
    userInfo: activeUser.user,
    isHide: false,
    isInput: false,
    student: {},
    students: []
  };
  $scope.toCheck = function() {
    $scope.ui.isHide = false;
    return $scope.ui.isInput = false;
  };
  (findParent = function() {
    if ($stateParams.status === 'parent') {
      return $http.get(config.api.baseUrl + "/cumpus/student", {
        params: {
          parent_openid: activeUser.user.openid,
          group_id: activeUser.group_id
        }
      }).then(function(res) {
        $scope.ui.students = res.data.data;
        return $timeout((function() {
          return ionicMaterialInk.displayEffect();
        }), 1000);
      })["catch"](function(error) {});
    }
  })();
  (findStudent = function() {
    if ($stateParams.status === 'student') {
      return $http.get(config.api.baseUrl + "/cumpus/student/" + $stateParams.user_id, {
        params: {
          openid: activeUser.user.openid,
          group_id: activeUser.group_id
        }
      }).then(function(res) {
        $scope.ui.student = res.data;
        return $timeout((function() {
          return ionicMaterialInk.displayEffect();
        }), 1000);
      })["catch"](function(error) {});
    }
  })();
  $scope.toAuthenticationInfo = function() {
    return $state.go("app.authentication_info", {
      status: '1'
    });
  };
  $scope.delParent = function(student) {
    var confirmPopup;
    return confirmPopup = $ionicPopup.confirm({
      title: "解除驗證",
      template: "您确定解除“學號：" + student.student_num + "，年級：" + student.student_grade + "，班級：" + student.student_class + "”的驗證吗?",
      buttons: [
        {
          text: '<b>取消</b>',
          type: 'button-light'
        }, {
          text: '<b>确定</b>',
          type: 'button-positive',
          onTap: function(e) {
            return doRemoveParent(student);
          }
        }
      ]
    });
  };
  $scope.deauthentication = function() {
    var confirmPopup;
    if ($stateParams.status === 'parent') {
      return confirmPopup = $ionicPopup.confirm({
        title: "解除驗證",
        template: "您确定解除全部驗證吗?",
        buttons: [
          {
            text: '<b>取消</b>',
            type: 'button-light'
          }, {
            text: '<b>確定</b>',
            type: 'button-positive',
            onTap: function(e) {
              return doRemoveParents();
            }
          }
        ]
      });
    } else {
      return confirmPopup = $ionicPopup.confirm({
        title: "解除驗證",
        template: "您确定解除驗證吗?",
        buttons: [
          {
            text: '<b>取消</b>',
            type: 'button-light'
          }, {
            text: '<b>確定</b>',
            type: 'button-positive',
            onTap: function(e) {
              return doRemoveStudent();
            }
          }
        ]
      });
    }
  };
  doRemoveParent = function(student) {
    _.each(student.parents, function(parent, index) {
      if (parent.openid === activeUser.user.openid) {
        return student.parents.splice(index, 1);
      }
    });
    return $http.put(config.api.baseUrl + "/cumpus/student/" + student._id, {
      parents: student.parents
    }).then(function(res) {
      return findParent();
    })["catch"](function(error) {
      return $ionicPopup.alert({
        title: "錯誤",
        template: "解除驗證失敗！",
        buttons: [
          {
            text: '<b>關閉</b>',
            type: 'button-positive'
          }
        ]
      });
    });
  };
  doRemoveParents = function() {
    return $http["delete"](config.api.baseUrl + "/cumpus/certification/parents?openid=" + activeUser.user.openid, {}).then(function(res) {
      return $state.go("app.authentication_info", {
        status: '1'
      });
    })["catch"](function(error) {
      return $ionicPopup.alert({
        title: "錯誤",
        template: "解除驗證失敗！",
        buttons: [
          {
            text: '<b>關閉</b>',
            type: 'button-positive'
          }
        ]
      });
    });
  };
  return doRemoveStudent = function() {
    return $http.put(config.api.baseUrl + "/cumpus/student/" + $stateParams.user_id, {
      openid: ''
    }).then(function(res) {
      return $state.go("app.authentication_info", {
        status: '1'
      });
    })["catch"](function(error) {
      return $ionicPopup.alert({
        title: "錯誤",
        template: "解除驗證失敗！",
        buttons: [
          {
            text: '<b>關閉</b>',
            type: 'button-positive'
          }
        ]
      });
    });
  };
});

angular.module('app').constant('config', {
  api: {
    baseUrl: '/api'
  }
});

angular.module('app').factory('activeUser', function() {
  return {};
});
